//TODO: Comment and add unit tests
import { PubSub, ConfigObj } from './'

// Private store reference
let _stores = {}

const instance = name => Object.create({

  get: () => Object.assign({}, _stores[name]),

  set: (storeProp, payload) => {
    const store = _stores[name]

    if (payload == store[storeProp]) return

    store[storeProp] = ConfigObj.merge(store[storeProp], payload)

    PubSub.publish('state:change', { stateId: name })
  }

})

const StateManager = (name, store) => {
  if (!name || !store) return

  _stores[name] = store
  return instance(name)
}

export default StateManager



// WEBPACK FOOTER //
// ./js/utils/StateManager.js